<div [attr.section-name]="sectionName"
     appIntersectionObserver
     (visibilityChange)="onVisibilityChanged($event)">
  <h3>Basic Information</h3>

  <section>
    <app-editable-textual-input [fieldId]="'businessName'"
                                [iconName]="'storefront_outline'"
                                [isFieldWithDataSource]="isFieldWithDataSource('businessName')"
                                [hasActiveConnection]="hasActiveConnection('businessName') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [subtype]="'link'"
                                [fieldId]="'website'"
                                [iconName]="'public'"
                                [isFieldWithDataSource]="isFieldWithDataSource('website')"
                                [hasActiveConnection]="hasActiveConnection('website') | ngrxPush"
    ></app-editable-textual-input>

    <app-editable-textual-input [subtype]="'comment'"
                                [fieldId]="'comment'"
                                [iconName]="'comment'"
                                [isFieldWithDataSource]="isFieldWithDataSource('comment')"
                                [hasActiveConnection]="hasActiveConnection('comment') | ngrxPush"
    ></app-editable-textual-input>


  </section>
</div>